import curd from '../curd'

const BASE_PATH = '/site'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/Site.js